import { useAppState } from "../context/appStateContext"
import localizations from "./localizationData"

function useStrings() {
  const { state } = useAppState()

  const language = state.initialData?.language

  let result = localizations.en

  if (language != null) {
    const key = language.split("-")[0]

    result = (localizations as any)[key] ?? localizations.en
  }

  return result
}

export default useStrings
